module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/sciabarra.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/sciabarra.jpg
// module id = 613
// module chunks = 0